<template>
  <datetime
            :input-id="$attrs.inputId"
            :placeholder="$attrs.placeholder"
            v-model="dateTimeVal"
            type="datetime"
            format="cccc, LLLL dd yyyy hh:mm a"
            input-class="picker"
            :phrases="{ok: 'Continue', cancel: 'Cancel'}"
            :hour-step="1"
            :minute-step="60"
            :week-start="7"
            use12-hour
            auto
            @focus="focusDateTime()"
            @close="closeDateTime()">
  </datetime>
</template>

<script>
export default {
  name: 'DatePicker',
  props: ['value'],
  data() {
    return {
      minDatetime: new Date().toISOString(),
      dateTimeVal: null,
    };
  },
  watch: {
    value() {
      this.dateTimeVal = this.value;
    },
    dateTimeVal(val) {
      this.$emit('input', val);
    },
  },
  methods: {
    focusDateTime() {
      document.body.classList.add('opened-date-picker');
    },
    closeDateTime() {
      document.body.classList.remove('opened-date-picker');
    },
  },
  mounted() {
    if (this.value) {
      this.dateTimeVal = this.value;
    }
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DatePicker.vue